import xss from "xss";

const allowedListItemClass = /^ql-indent-[0-9]$/;
const allowedTextSizeClass = /^ql-size-(small|large|huge)$/;
const allowedClassTags = ["li", "span"];

const articleContentXssOptions = {
  whiteList: {
    ...xss.whiteList,
    li: [...(xss.whiteList.li || []), "class"],
    span: [...(xss.whiteList.span || []), "class"]
  },
  onTagAttr: (tag, name, value) => {
    if (!allowedClassTags.includes(tag) || name !== "class") return undefined;

    const safeClasses = String(value)
      .split(/\s+/)
      .filter(className =>
        tag === "li"
          ? allowedListItemClass.test(className) ||
            allowedTextSizeClass.test(className)
          : allowedTextSizeClass.test(className)
      );

    return safeClasses.length ? `class="${safeClasses.join(" ")}"` : "";
  }
};

export const sanitizeArticleContent = html =>
  xss(html || "", articleContentXssOptions);
